import { FaGithub } from "react-icons/fa"
import { FiGitlab } from "react-icons/fi"
import { RepoI } from ".."

export const repos: RepoI[] = [
  {
    git: "Gitlab",
    description: "https://gitlab.com/diornister",
    icon: FiGitlab,
    color: "orange",
  },
  {
    git: "Github",
    description: "https://github.com/diornister",
    icon: FaGithub,
    color: "black",
  },
]
